<template>
	<modal ref="modal" size="modal-lg">
		<template #title>FB Group Information</template>
		<template #body>
			<div class="form-floating mb-4">
				<div class="form-control">{{form.current_rank}}</div>
				<label class="form-label">Subscription</label>
			</div>
			<div class="form-floating mb-4">
				<div class="form-control">{{form.username}}</div>
				<label class="form-label">Email</label>
			</div>
			<div class="form-floating mb-4">
				<div class="form-control">{{form.fname}} {{form.lname}}</div>
				<label class="form-label">Member's Name</label>
			</div>
			<div class="form-floating mb-4">
				<div class="form-control" :class="{'text-success':form.expired=='No','text-danger':form.expired=='Yes'}">{{form.expired}}</div>
				<label class="form-label">Expired</label>
			</div>
			<div class="form-floating mb-4">
				<div class="form-control">
					<a v-if="form.c_fblink!==null" :href="form.c_fblink" class="text-info" target="_blank">{{form.c_fblink}}</a>
					<span v-if="form.c_fblink==null" class="text-danger">NONE</span>
				</div>
				<label class="form-label">FB Profile Link</label>
			</div>
			<div class="my-3">
				<h6>Social Group List</h6>
				<div class="table-responsive">
					<table class="table table-borderless" :class="{'table-hover':cur_index==null}">
						<thead>
							<tr>
								<th>Group Name</th>
								<th>Group Link</th>
								<th>Is Added</th>
								<th>Added</th>
								<th>Updated</th>
								<th class="text-end">::::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(social,s_index) in socialGroups" :class="{'bg-selected':cur_index==s_index}">
								<td>{{social.group_name}}</td>
								<td>{{social.group_link}}</td>
								<td>
									<span v-if="social.is_added==1" class="text-success">Yes</span>
									<span v-if="social.is_added==0" class="text-danger">No</span>
								</td>
								<td>{{social.date_added_formatted}}</td>
								<td>{{social.date_updated_formatted}}</td>
								<td class="text-end">
									<button @click="editContent(s_index)" type="button" class="btn btn-sm btn-info" :disabled="action=='update'"><i class="fa fa-edit"></i></button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="my-4 border-top pt-4 border-info border-3">

					<div class="form-floating mb-4">
						<input v-model="selected_mem.group_name" type="text" name="group_name" class="form-control"/>
						<label class="form-label">Group Name</label>
					</div>
					<div class="form-floating mb-4">
						<input v-model="selected_mem.group_link" type="text" name="group_name" class="form-control"/>
						<label class="form-label">Group Link</label>
					</div>
					<div class="form-floating mb-4">
						<select v-model="selected_mem.is_added" class="form-control">
							<option value="1">Yes</option>
							<option value="0">No</option>
						</select>
						<label class="form-label">Is Added</label>
					</div>
					<div class="text-center">
						<button @click="actionContent" type="button" class="btn btn-success"><i class="fa fa-save me-1"></i>Save</button>
						<button v-if="action=='update'" @click="cancelEdit" type="button" class="btn btn-alt-secondary ms-2"><i class="fa fa-times me-1"></i>Cancel</button>
					</div>
				</div>
			</div>
		</template>
	</modal>
</template>

<script>
	import { watch, ref, reactive } from 'vue'
	import { useForm } from '@inertiajs/inertia-vue3'
	import { Inertia } from '@inertiajs/inertia';


	export default {
		props:{
			socialGroups : Object
		},
		setup(props){
			const modal 		= ref(null);

			const toggleModal 	= () => { 
									cancelEdit();
									modal.value.toggleModal();
								}

			const form 			= useForm({});

			const selected_mem 	= useForm({
									group_id 	: 0,
									member_id 	: 0,
									group_name	: '',
									group_link	: '',
									is_added	: 0
								});

			const action = ref('add');

			const cur_index = ref(null);

			const editContent =(_index)=>{
				cur_index.value = _index;
				action.value 	= "update";
				var selected 	= props.socialGroups[_index];

				selected_mem.group_id 	= selected.group_id;
				selected_mem.member_id 	= selected.member_id;
				selected_mem.group_name = selected.group_name;
				selected_mem.group_link = selected.group_link;
				selected_mem.is_added 	= selected.is_added;

			}

			const cancelEdit = ()=>{
				cur_index.value = null;
				action.value 	= 'add';

				selected_mem.group_id 	= 0;
				selected_mem.member_id 	= 0;
				selected_mem.group_name = '';
				selected_mem.group_link = '';
				selected_mem.is_added 	= 0;
			}

			const actionContent = ()=>{
				if(action.value=="update")
				{
					updateContent();
				}else
				{
					selected_mem.member_id = form.member_id;
					addContent();
				}
			}

			const addContent =()=>{
				selected_mem.post(route('admin.post.fb-group-management'), {
					preserveState: true,
					preserveScroll: true,
					only:['socialGroups,api_response,errors'],
					onSuccess: () => {
						selected_mem.reset();
					},
				})
			}

			const updateContent =()=>{
				selected_mem.put(route('admin.put.fb-group-management',{group_id:selected_mem.group_id}), {
					preserveState: true,
					preserveScroll: true,
					only:['socialGroups,api_response,errors'],
					onSuccess: () => {
						selected_mem.reset();
						cancelEdit();
					},
				})
			}

			const setMember = (data)=>{
								form.member_id 		= data.member_id;
								form.username 		= data.username;
								form.current_rank 	= data.current_rank;
								form.fname 			= data.fname;
								form.lname 			= data.lname;
								form.expired 		= data.expired;
								form.c_fblink 		= data.c_fblink;
							}

			watch(()=>form.member_id, (value) => {
				Inertia.visit(
					route('admin.fb-group-management',{member_id:value}),
					{
						preserveState: true,
						preserveScroll: true,
						only: ['socialGroups']
					}
				)
			})

			return{
				modal,
				toggleModal,
				form,
				selected_mem,
				setMember,
				action,
				cur_index,
				editContent,
				cancelEdit,
				actionContent,
				addContent,
				updateContent
			}
		}

	}
</script>